<template>
  <b-form v-if="school.loaded()" :autocomplete=autoComplete>

    <b-form-group horizontal label-for="name" label="Name der Schule *" description=" *Bitte geben Sie den offiziellen, vollständigen Namen der Schule ein, so wie er dann auch auf den Urkunden stehen soll">
      <b-form-input type="text" id="name" v-model="school.name" :autocomplete="autoComplete" required/>
    </b-form-group>

    <b-form-group horizontal label-for="email" label="Email-Adresse der Schule">
      <b-form-input type="text" id="name" v-model="school.email" :autocomplete="autoComplete" required/>
    </b-form-group>

    <b-form-group horizontal label-for="address" label="Adresse*" description="*Enter für weitere Zeilen">
      <b-form-textarea id="address" v-model="school.address" :autocomplete="autoComplete" required/>
    </b-form-group>

    <b-form-group horizontal label-for="zip" label="Postleitzahl">
      <b-form-input type="text" id="zip" v-model="school.zip" :autocomplete="autoComplete" required/>
    </b-form-group>

    <b-form-group horizontal label-for="city" label="Ort">
      <b-form-input type="text" id="city" v-model="school.city" :autocomplete="autoComplete" required/>
    </b-form-group>

    <b-form-group horizontal label-for="state" label="Bundesland" label-cols-md="3">
      <form-option-state v-if="school.state.code" :country="school.country" :state="school.state.code" @selected="setState"></form-option-state>
    </b-form-group>

    <div class="mt-5 text-right">
      <b-button type="button" v-on:click="save" variant="primary" :disabled="!school.changed()">
        Speichern
      </b-button>
    </div>
  </b-form>
</template>
<script>
import FormOptionState from '@/components/misc/FormOptionState'

export default {
  name: 'SchoolsAddress',
  props: ['school', 'autocomplete'],

  components: {
    FormOptionState: FormOptionState
  },

  computed: {
    autoComplete: function () {
      return this.autocomplete ? 'on' : 'off'
    }
  },

  methods: {
    setState: function (value) {
      if (value !== this.school.state.code) {
        this.school.state.code = value
        this.school.state.name = ''
      }
    },

    save: function () {
      this.school.save()
        .then(() => {
          this.$eventHub.$emit('info', 'Änderungen gespeichert')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schools/Address.vue